import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../_services';
import { DecryptPipe } from '../_services/encrypt-decrypt.pipe';
import { Helpers } from '../../helpers';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-logout-new',
  templateUrl: './logout-new.component.html',
  styleUrls: ['./logout-new.component.scss']
})
export class LogoutNewComponent implements OnInit {

  isTransporter: boolean = false;
  isCustomer: boolean = false;

  constructor(
    private _router: Router,
    private _authService: AuthenticationService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe
  ) { }

  ngOnInit() {
    this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
    this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));
    // added by vithu 12-03-2025
    var userId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId")));
    Helpers.setLoading(true);
    // reset login status
    this._authService.logout(userId);
    if (environment.apiUrl == 'https://nol.ifreightbox.net/') {
      if (this.isTransporter || this.isCustomer) {
        this._router.navigate(["/home"]);
      } else {
        this._router.navigate(["/NewLogin"]);
      }
    }
    else {
      let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
      if (UserRole == '["Pre-Customer"]') {
        this._router.navigate(["/home/tabs/login/customer"]);
      } else {
        this._router.navigate(["/NewLogin"]);
      }
    }
    this.cookieService.deleteAll();
  }

}
